import React from "react";
import { Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import theme from "../../styles/theme.ts";

export default function Header({
  text,
  children,
  backgroundColor = theme.palette.primary.main,
}: {
  text: string;
  children: React.ReactNode;
  backgroundColor?: string;
}) {
  return (
    <Grid
      container
      className="header-box"
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{
        background: backgroundColor,
      }}
    >
      <Grid>
        <img
          src={"/dots-background-left.svg"}
          alt=""
          className="background-dots-left"
        />
      </Grid>
      <Grid>
        <Stack alignItems="center" direction="row" gap={1}>
          <img src={"/logo.svg"} alt="logo-icon" />
          <Typography variant="h5" className="header-text">
            {text}
          </Typography>
        </Stack>
        {children}
      </Grid>
      <Grid>
        <img
          src={"/dots-background-right.svg"}
          alt=""
          className="background-dots-right"
        />
      </Grid>
    </Grid>
  );
}
